import styled from 'styled-components';
import { Link } from 'gatsby';

export default styled(Link)`
  display: block;
  color: white;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-weight: 700;
  text-decoration: none;
  padding: 8px 0;

  &:hover {
    color: ${(props) => props.theme.primaryColor};
  }
`;
